/**
 * Update notification component
 * Shows a toast when new version is available
 */

import React from 'react';
import './UpdateNotification.css';

interface UpdateNotificationProps {
  /**
   * Whether notification is visible
   */
  visible: boolean;

  /**
   * Countdown in seconds until auto-reload
   * 0 means no auto-reload
   */
  countdown?: number;

  /**
   * Callback to reload immediately
   */
  onReload: () => void;

  /**
   * Callback to dismiss notification
   */
  onDismiss?: () => void;
}

export function UpdateNotification({
  visible,
  countdown = 0,
  onReload,
  onDismiss,
}: UpdateNotificationProps) {
  if (!visible) {
    return null;
  }

  return (
    <div className="update-notification" role="alert">
      <div className="update-notification-content">
        <div className="update-notification-icon">🔔</div>
        <div className="update-notification-message">
          <strong>New version available!</strong>
          {countdown > 0 && (
            <div className="update-notification-countdown">
              Refreshing in {countdown}s...
            </div>
          )}
        </div>
      </div>
      <div className="update-notification-actions">
        <button
          type="button"
          className="update-notification-button primary"
          onClick={onReload}
        >
          Reload now
        </button>
        {onDismiss && (
          <button
            type="button"
            className="update-notification-button secondary"
            onClick={onDismiss}
          >
            Dismiss
          </button>
        )}
      </div>
    </div>
  );
}
